module.exports = __webpack_public_path__ + "static/img/bannerBg.186a2fa9.jpg";